import React, { useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import {
  IonSlides,
  IonSlide,
  IonButton,
  getPlatforms
} from '@ionic/react'
import YokIcon from '../../../components/common/YokIcon'
import ProductSquaredCard from '../../../components/common/ProductSquaredCard'
import './styles.scss'

const PodcastCategorySwipper = props => {
  const { category } = props
  const products = category.products || []
  const [isBeginning, SetIsBeginning] = useState(true)
  const [isEnd, SetIsEnd] = useState(false)
  const [showNavigation, setShowNavigation] = useState(false)
  const slidesRef = useRef()
  const slideOpts = {
    initialSlide: 0,
    slidesPerView: 'auto',
    preventClicks: true,
    speed: 400,
    pagination: true
  }
  const slideWdth = 120

  const transitionEnd = () => {
    slidesRef.current.isBeginning().then((response) => { SetIsBeginning(response) })
    slidesRef.current.isEnd().then((response) => { SetIsEnd(response) })
  }

  const prevSlide = () => {
    slidesRef.current.slidePrev()
  }

  const nextSlide = () => {
    slidesRef.current.slideNext()
  }

  useEffect(() => {
    if (typeof slidesRef.current !== 'undefined' && typeof products !== 'undefined') {
      setShowNavigation((slideWdth * products.length > slidesRef.current.clientWidth) && getPlatforms().includes('desktop'))
    }
  }, [])

  return (
    <section className='podcast-category-swipper'>
      {category &&
        <Link
          to={`/podcast/${category.category_alias}`}
          aria-label={`Ver todos los episodios de ${category.category}`}
        >
          <h1 className='category-title'>{category.category}</h1>
        </Link>}
      <IonSlides
        ref={slidesRef}
        options={slideOpts}
        onIonSlideDidChange={() => transitionEnd()}
      >
        {products.map((product, id) => (
          <IonSlide key={product.id}>
            <ProductSquaredCard
              product={product}
            />
          </IonSlide>
        ))}
      </IonSlides>
      {showNavigation &&
        <>
          <IonButton
            className='pagination prev'
            onClick={prevSlide}
            disabled={isBeginning}
          >
            <YokIcon name='arrow_back_ios' />
          </IonButton>
          <IonButton
            className='pagination next'
            onClick={nextSlide}
            disabled={isEnd}
          >
            <YokIcon name='arrow_forward_ios' />
          </IonButton>
        </>}
    </section>
  )
}

export default PodcastCategorySwipper
